export default "__VITE_ASSET__islS735G__"